import Long from 'long';
import Message from '../../Message';
import Chat from '../Chat';
import { IMCMessage } from '../../../api/proto';

export default function generateRandomMessage(localID: Long, chat: Chat): Message {
  const raw: IMCMessage = {
    localID,
    chatID: chat.id,
    text: `Random message ${Math.random().toString(36).slice(2, 10)}`,
    sentAt: Long.fromNumber(Date.now() / 1000 | 0),
    operatorID: chat.channel?.app.userStore.userId || Long.UZERO,
  };

  return new Message(raw, chat);
}